import { attractions } from "@/mocks/homeData";

const ATTRACTION_IMAGE_ALT: Record<string, string> = {
  canyons: "Cânions de Capitólio vistos durante passeio de lancha no Lago de Furnas",
  "lagoa-azul": "Lagoa Azul de Capitólio com águas cristalinas no Lago de Furnas",
  "vale-dos-tucanos": "Vale dos Tucanos em Capitólio durante passeio de lancha no Mar de Minas",
  "cachoeira-da-gruta": "Cachoeira da Gruta em Capitólio no roteiro de passeio de lancha",
  "bares-flutuantes": "Bares flutuantes do Lago de Furnas em Capitólio",
  "cachoeira-das-orquideas":
    "Cachoeira das Orquídeas, parada para banho no Lago de Furnas em Capitólio",
};

const ATTRACTION_ANCHOR: Record<string, string> = {
  canyons: "canyons-capitolio",
  "lagoa-azul": "lagoa-azul",
  "vale-dos-tucanos": "vale-dos-tucanos",
  "cachoeira-da-gruta": "cachoeira-da-gruta",
  "bares-flutuantes": "bares-flutuantes",
  "cachoeira-das-orquideas": "cachoeira-das-orquideas",
};

export default function Attractions() {
  return (
    <section id="roteiros" className="relative py-7 md:py-12 bg-background-100 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1500px] mx-auto">
          <div className="text-center mb-5 md:mb-8 reveal">
            <span className="inline-block text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-3">
              Roteiro do passeio
            </span>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-primary-900 mb-3">
              Conheça o Lago de Furnas e o Mar de Minas
            </h2>
            <p className="text-xs md:text-sm text-foreground-600 max-w-xl mx-auto">
              Um roteiro completo pelos lugares mais bonitos do Lago de Furnas, em Capitólio.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
            {attractions.map((item, index) => (
              <article
                key={item.id}
                id={ATTRACTION_ANCHOR[item.id]}
                className={`reveal reveal-delay-${(index % 3) + 1} group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-500/60 transition-all duration-300 scroll-mt-16`}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={item.image}
                    alt={ATTRACTION_IMAGE_ALT[item.id] ?? item.title}
                    title={`${ATTRACTION_IMAGE_ALT[item.id] ?? item.title} | Eco Tour Turismo`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute bottom-2 right-2 w-7 h-7 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-600 text-sm`} />
                  </span>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-xs md:text-base font-heading font-bold text-primary-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-[10px] md:text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}